import React, { useState, useEffect } from 'react';
import { Plus, Trash2, ChevronDown, ChevronUp, MessageSquare, GripVertical } from 'lucide-react';
import { initializeApp } from 'firebase/app';
import { getDatabase, ref, set, onValue, remove } from 'firebase/database';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA8N51_9llK6xtspF0KY_sJyZnXCpxEoP8",
  authDomain: "todolings.firebaseapp.com",
  databaseURL: "https://todolings-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "todolings",
  storageBucket: "todolings.firebasestorage.app",
  messagingSenderId: "1078422495030",
  appId: "1:1078422495030:web:6d98d95deeb9711c609d97"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const BurgerMenu = ({ currentPage, onPageChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          position: 'fixed',
          top: '20px',
          left: '20px',
          backgroundColor: '#403D38',
          border: 'none',
          borderRadius: '7px',
          padding: '12px',
          cursor: 'pointer',
          zIndex: 2000,
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          transition: 'all 0.3s ease'
        }}
      >
        <div style={{
          width: '15px',
          height: '2px',
          backgroundColor: '#FFFDF1',
          transition: 'all 0.3s ease',
          transform: isOpen ? 'rotate(45deg) translateY(6px)' : 'none'
        }} />
        <div style={{
          width: '15px',
          height: '2px',
          backgroundColor: '#FFFDF1',
          transition: 'all 0.3s ease',
          opacity: isOpen ? 0 : 1
        }} />
        <div style={{
          width: '15px',
          height: '2px',
          backgroundColor: '#FFFDF1',
          transition: 'all 0.3s ease',
          transform: isOpen ? 'rotate(-45deg) translateY(-6px)' : 'none'
        }} />
      </button>

      {isOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            zIndex: 1999,
            animation: 'fadeIn 0.3s ease'
          }}
          onClick={() => setIsOpen(false)}
        >
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '250px',
              height: '100vh',
              backgroundColor: '#403D38',
              padding: '80px 20px 20px 20px',
              animation: 'slideIn 0.3s ease',
              fontFamily: 'IBM Plex Mono, monospace'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              onClick={() => {
                onPageChange('tasks');
                setIsOpen(false);
              }}
              style={{
                padding: '16px',
                color: currentPage === 'tasks' ? '#63B9AB' : '#FFFDF1',
                cursor: 'pointer',
                borderRadius: '7px',
                marginBottom: '8px',
                backgroundColor: currentPage === 'tasks' ? 'rgba(99, 185, 171, 0.1)' : 'transparent',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                if (currentPage !== 'tasks') {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 253, 241, 0.05)';
                }
              }}
              onMouseLeave={(e) => {
                if (currentPage !== 'tasks') {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }
              }}
            >
              tasks
            </div>
            <div
              onClick={() => {
                onPageChange('admin');
                setIsOpen(false);
              }}
              style={{
                padding: '16px',
                color: currentPage === 'admin' ? '#63B9AB' : '#FFFDF1',
                cursor: 'pointer',
                borderRadius: '7px',
                backgroundColor: currentPage === 'admin' ? 'rgba(99, 185, 171, 0.1)' : 'transparent',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                if (currentPage !== 'admin') {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 253, 241, 0.05)';
                }
              }}
              onMouseLeave={(e) => {
                if (currentPage !== 'admin') {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }
              }}
            >
              admin
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideIn {
          from { transform: translateX(-100%); }
          to { transform: translateX(0); }
        }
      `}</style>
    </>
  );
};
const InvoiceRow = ({ invoice, onUpdate, onDelete, onMarkPaid, onDragStart, onDragOver, onDrop }) => {
  const [localName, setLocalName] = useState(invoice.name);
  const [localProject, setLocalProject] = useState(invoice.project);
  const [localSum, setLocalSum] = useState(invoice.sum);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    setLocalName(invoice.name);
    setLocalProject(invoice.project);
    setLocalSum(invoice.sum);
  }, [invoice.name, invoice.project, invoice.sum]);

  const getStatusColor = () => {
  if (invoice.status === 'planned') return '#FFFDF1'; // White/cream for planned
  if (invoice.paid) return '#63B9AB'; // Teal for paid
  if (!invoice.deadline) return '#63B9AB'; // Green for emitted
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const deadlineDate = new Date(invoice.deadline);
  deadlineDate.setHours(0, 0, 0, 0);
  
  if (deadlineDate < today) return '#DA693E'; // Red/coral for overdue
  return '#63B9AB'; // Green for emitted
  };

  const getStatusText = () => {
  if (invoice.status === 'planned') return 'planned';
  if (invoice.paid) return 'paid';
  if (!invoice.deadline) return 'emitted';
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const deadlineDate = new Date(invoice.deadline);
  deadlineDate.setHours(0, 0, 0, 0);
  
  if (deadlineDate < today) return 'overdue';
  return 'emitted';
  };

  return (
    <div 
      style={{
        marginBottom: '8px',
        display: 'grid',
        gridTemplateColumns: '24px 1.5fr 1fr 0.8fr 0.8fr 0.8fr 120px 35px 35px',
        gap: '8px',
        transform: isEditing ? 'translateY(-2px)' : 'none',
        filter: isEditing ? 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3))' : 'none',
        transition: 'transform 0.2s ease, filter 0.2s ease',
        backgroundColor: '#403D38',
        padding: '12px 16px',
        borderRadius: '7px',
        alignItems: 'center',
        fontFamily: 'IBM Plex Mono, monospace',
        fontSize: '13px',
        color: '#FFFDF1'
      }}
    >
      {/* Drag handle */}
      <div
        draggable
        onDragStart={(e) => onDragStart(e, invoice)}
        onDragOver={onDragOver}
        onDrop={(e) => onDrop(e, invoice)}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'grab',
          color: '#FFFDF1',
          opacity: 0.5,
          transition: 'opacity 0.2s ease'
        }}
        onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
        onMouseLeave={(e) => e.currentTarget.style.opacity = '0.5'}
      >
        <GripVertical size={16} />
      </div>

      {/* Invoice name */}
      <input
        type="text"
        value={localName}
        onChange={(e) => setLocalName(e.target.value)}
        onBlur={(e) => {
          onUpdate(invoice.id, 'name', e.target.value);
          setIsEditing(false);
        }}
        onFocus={() => setIsEditing(true)}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        style={{
          backgroundColor: 'transparent',
          border: 'none',
          color: '#FFFDF1',
          fontFamily: 'IBM Plex Mono, monospace',
          fontSize: '13px',
          outline: 'none',
          width: '100%'
        }}
      />

      {/* Project */}
      <input
        type="text"
        value={localProject}
        onChange={(e) => setLocalProject(e.target.value)}
        onBlur={(e) => {
          onUpdate(invoice.id, 'project', e.target.value);
          setIsEditing(false);
        }}
        onFocus={() => setIsEditing(true)}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        placeholder="project"
        style={{
          backgroundColor: 'transparent',
          border: 'none',
          color: '#FFFDF1',
          fontFamily: 'IBM Plex Mono, monospace',
          fontSize: '13px',
          outline: 'none',
          width: '100%'
        }}
      />

      {/* Sum */}
      <input
        type="text"
        value={localSum}
        onChange={(e) => setLocalSum(e.target.value)}
        onBlur={(e) => {
          onUpdate(invoice.id, 'sum', parseFloat(e.target.value) || 0);
          setIsEditing(false);
        }}
        onFocus={() => setIsEditing(true)}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        placeholder="0"
        style={{
          backgroundColor: 'transparent',
          border: 'none',
          color: '#FFFDF1',
          fontFamily: 'IBM Plex Mono, monospace',
          fontSize: '13px',
          outline: 'none',
          width: '100%'
        }}
      />

      {/* Status */}
        <div style={{ 
          color: getStatusColor(),
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
          }}>
          {getStatusText() === 'planned' && (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
          )}
          {getStatusText() === 'emitted' && (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
          )}
          {getStatusText() === 'overdue' && (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          )}
          {getStatusText() === 'paid' && (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          )}
          {getStatusText()}
        </div>

      {/* Location */}
      <select
        value={invoice.location}
        onChange={(e) => onUpdate(invoice.id, 'location', e.target.value)}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        style={{
          backgroundColor: '#403D38',
          border: 'none',
          color: '#FFFDF1',
          fontFamily: 'IBM Plex Mono, monospace',
          fontSize: '13px',
          outline: 'none',
          cursor: 'pointer'
        }}
      >
        <option value="Dubai">Dubai</option>
        <option value="Romania">Romania</option>
      </select>

      {/* Deadline */}
      <input
        type="date"
        value={invoice.deadline}
        onChange={(e) => onUpdate(invoice.id, 'deadline', e.target.value)}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        style={{
          backgroundColor: '#403D38',
          border: 'none',
          color: '#FFFDF1',
          fontFamily: 'IBM Plex Mono, monospace',
          fontSize: '13px',
          outline: 'none',
          cursor: 'pointer',
          colorScheme: 'dark'
        }}
      />

      {/* Action button - Emit or Mark Paid */}
        {invoice.status === 'planned' ? (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onUpdate(invoice.id, 'status', 'emitted');
            }}
            className="icon-button"
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: '#63B9AB',
              cursor: 'pointer',
              padding: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'opacity 0.2s ease, transform 0.2s ease'
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="22" y1="2" x2="11" y2="13"></line>
              <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
            </svg>
          </button>
        ) : !invoice.paid ? (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onMarkPaid(invoice.id);
            }}
            className="icon-button"
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: '#63B9AB',
              cursor: 'pointer',
              padding: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'opacity 0.2s ease, transform 0.2s ease'
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </button>
        ) : null}

      {/* Delete button */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onDelete(invoice.id);
        }}
        className="icon-button"
        style={{
          backgroundColor: 'transparent',
          border: 'none',
          color: '#DA693E',
          cursor: 'pointer',
          padding: '4px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'opacity 0.2s ease, transform 0.2s ease'
        }}
      >
        <Trash2 size={16} />
      </button>
    </div>
  );
};
const TaskRow = ({ task, onUpdate, onDelete, onDragStart, onDragOver, onDrop }) => {
  const [localTask, setLocalTask] = useState(task.task);
  const [localProject, setLocalProject] = useState(task.project);
  const [showCommentPopup, setShowCommentPopup] = useState(false);
  const [localComment, setLocalComment] = useState(task.comment || '');
  const [isEditing, setIsEditing] = useState(false);
  const [customPerson, setCustomPerson] = useState(
    !['andra', 'serj', 'both'].includes(task.person) ? task.person : ''
  );
  const [showCustomInput, setShowCustomInput] = useState(
    !['andra', 'serj', 'both'].includes(task.person)
  );

  // Update local state when task prop changes (from Firebase)
  useEffect(() => {
    setLocalTask(task.task);
    setLocalProject(task.project);
    setLocalComment(task.comment || '');
  }, [task.task, task.project, task.comment]);

  const handlePersonChange = (value) => {
    if (value === 'other') {
      setShowCustomInput(true);
      setCustomPerson('');
    } else {
      setShowCustomInput(false);
      onUpdate(task.id, 'person', value);
    }
  };

  const handleCustomPersonChange = (value) => {
    setCustomPerson(value);
    onUpdate(task.id, 'person', value);
  };

  const handleCommentSave = () => {
    onUpdate(task.id, 'comment', localComment);
    setShowCommentPopup(false);
  };

  const getPriorityColor = (priority) => {
    switch(priority) {
      case 'high': return '#DA693E';
      case 'medium': return '#63B9AB';
      case 'low': return '#FFFDF1';
      default: return '#FFFDF1';
    }
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'to do': return '#FFFDF1';
      case 'in progress': return '#63B9AB';
      case 'done': return '#DA693E';
      default: return '#FFFDF1';
    }
  };

  return (
    <>
      <div 
        style={{
          marginBottom: '8px',
          display: 'grid',
          gridTemplateColumns: '24px 1.5fr 1fr 100px 2fr',
          gap: '8px',
          transform: isEditing ? 'translateY(-2px)' : 'none',
          filter: isEditing ? 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3))' : 'none',
          transition: 'transform 0.2s ease, filter 0.2s ease'
        }}
      >
        {/* Drag handle */}
        <div
          draggable
          onDragStart={(e) => onDragStart(e, task)}
          onDragOver={onDragOver}
          onDrop={(e) => onDrop(e, task)}
          style={{
            backgroundColor: '#403D38',
            borderRadius: '7px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'grab',
            color: '#FFFDF1',
            opacity: 0.5,
            transition: 'opacity 0.2s ease'
          }}
          onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
          onMouseLeave={(e) => e.currentTarget.style.opacity = '0.5'}
        >
          <GripVertical size={16} />
        </div>

        {/* Task name box */}
        <div
          style={{
            backgroundColor: '#403D38',
            padding: '12px 16px',
            borderRadius: '7px',
            fontFamily: 'IBM Plex Mono, monospace',
            fontSize: '13px',
            color: '#FFFDF1'
          }}
        >
          <input
            type="text"
            value={localTask}
            onChange={(e) => setLocalTask(e.target.value)}
            onBlur={(e) => {
              onUpdate(task.id, 'task', e.target.value);
              setIsEditing(false);
            }}
            onFocus={() => setIsEditing(true)}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: '#FFFDF1',
              fontFamily: 'IBM Plex Mono, monospace',
              fontSize: '13px',
              outline: 'none',
              width: '100%'
            }}
          />
        </div>

        {/* Project box */}
        <div
          style={{
            backgroundColor: '#403D38',
            padding: '12px 16px',
            borderRadius: '7px',
            fontFamily: 'IBM Plex Mono, monospace',
            fontSize: '13px',
            color: '#FFFDF1'
          }}
          >
          <input
            type="text"
            value={localProject}
            onChange={(e) => setLocalProject(e.target.value)}
            onBlur={(e) => {
              onUpdate(task.id, 'project', e.target.value);
              setIsEditing(false);
            }}
            onFocus={() => setIsEditing(true)}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            placeholder="project"
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: '#FFFDF1',
              fontFamily: 'IBM Plex Mono, monospace',
              fontSize: '13px',
              outline: 'none',
              width: '100%'
            }}
          />
        </div>

        {/* Person box */}
        <div
          style={{
            backgroundColor: '#403D38',
            padding: '12px 16px',
            borderRadius: '7px',
            display: 'flex',
            alignItems: 'center',
            fontFamily: 'IBM Plex Mono, monospace',
            fontSize: '13px',
            color: '#FFFDF1'
          }}
        >
          {showCustomInput ? (
            <input
              type="text"
              value={customPerson}
              onChange={(e) => handleCustomPersonChange(e.target.value)}
              onFocus={() => setIsEditing(true)}
              onBlur={() => setIsEditing(false)}
              placeholder="name"
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                color: '#FFFDF1',
                fontFamily: 'IBM Plex Mono, monospace',
                fontSize: '13px',
                outline: 'none',
                width: '100%'
              }}
            />
          ) : (
            <select
              value={task.person}
              onChange={(e) => handlePersonChange(e.target.value)}
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
              style={{
                backgroundColor: '#403D38',
                border: 'none',
                color: '#FFFDF1',
                fontFamily: 'IBM Plex Mono, monospace',
                fontSize: '13px',
                outline: 'none',
                cursor: 'pointer',
                width: '100%'
              }}
            >
              <option value="andra">andra</option>
              <option value="serj">serj</option>
              <option value="both">both</option>
              <option value="other">other</option>
            </select>
          )}
        </div>

        {/* Rest of info box */}
        <div
          style={{
            backgroundColor: '#403D38',
            padding: '12px 16px',
            borderRadius: '7px',
            display: 'grid',
            gridTemplateColumns: '100px 140px 120px 40px 40px',
            gap: '12px',
            alignItems: 'center',
            fontFamily: 'IBM Plex Mono, monospace',
            fontSize: '13px',
            color: '#FFFDF1'
          }}
        >
          <select
            value={task.priority}
            onChange={(e) => onUpdate(task.id, 'priority', e.target.value)}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            style={{
              backgroundColor: '#403D38',
              border: 'none',
              color: getPriorityColor(task.priority),
              fontFamily: 'IBM Plex Mono, monospace',
              fontSize: '13px',
              outline: 'none',
              cursor: 'pointer'
            }}
          >
            <option value="high" style={{backgroundColor: '#403D38', color: '#DA693E'}}>● high</option>
            <option value="medium" style={{backgroundColor: '#403D38', color: '#63B9AB'}}>● medium</option>
            <option value="low" style={{backgroundColor: '#403D38', color: '#FFFDF1'}}>● low</option>
          </select>

          <select
            value={task.status}
            onChange={(e) => onUpdate(task.id, 'status', e.target.value)}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            style={{
              backgroundColor: '#403D38',
              border: 'none',
              color: getStatusColor(task.status),
              fontFamily: 'IBM Plex Mono, monospace',
              fontSize: '13px',
              outline: 'none',
              cursor: 'pointer'
            }}
          >
            <option value="to do" style={{backgroundColor: '#403D38', color: '#FFFDF1'}}>○ to do</option>
            <option value="in progress" style={{backgroundColor: '#403D38', color: '#63B9AB'}}>◐ in progress</option>
            <option value="done" style={{backgroundColor: '#403D38', color: '#DA693E'}}>● done</option>
          </select>

          <input
            type="date"
            value={task.deadline}
            onChange={(e) => onUpdate(task.id, 'deadline', e.target.value)}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            style={{
              backgroundColor: '#403D38',
              border: 'none',
              color: '#FFFDF1',
              fontFamily: 'IBM Plex Mono, monospace',
              fontSize: '13px',
              outline: 'none',
              cursor: 'pointer',
              colorScheme: 'dark'
            }}
          />

          <button
            onClick={(e) => {
              e.stopPropagation();
              setShowCommentPopup(true);
            }}
            className="icon-button"
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: task.comment ? '#63B9AB' : '#FFFDF1',
              cursor: 'pointer',
              padding: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              opacity: task.comment ? 1 : 0.5,
              transition: 'opacity 0.2s ease, transform 0.2s ease'
            }}
          >
            <MessageSquare size={16} />
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              onDelete(task.id);
            }}
            className="icon-button"
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: '#DA693E',
              cursor: 'pointer',
              padding: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'opacity 0.2s ease, transform 0.2s ease'
            }}
          >
            <Trash2 size={16} />
          </button>
        </div>
      </div>

      {showCommentPopup && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
          }}
          onClick={() => setShowCommentPopup(false)}
        >
          <div
            style={{
              backgroundColor: '#403D38',
              padding: '24px',
              borderRadius: '7px',
              maxWidth: '500px',
              width: '90%',
              fontFamily: 'IBM Plex Mono, monospace'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{
              color: '#FFFDF1',
              fontSize: '16px',
              fontWeight: '400',
              marginTop: 0,
              marginBottom: '16px'
            }}>comment</h3>
            
            <textarea
              value={localComment}
              onChange={(e) => setLocalComment(e.target.value)}
              placeholder="add notes or details..."
              style={{
                width: '100%',
                minHeight: '120px',
                backgroundColor: '#252422',
                border: 'none',
                borderRadius: '7px',
                padding: '12px',
                color: '#FFFDF1',
                fontFamily: 'IBM Plex Mono, monospace',
                fontSize: '13px',
                outline: 'none',
                resize: 'vertical',
                marginBottom: '16px'
              }}
            />
            
            <div style={{display: 'flex', gap: '8px', justifyContent: 'flex-end'}}>
              <button
                onClick={() => setShowCommentPopup(false)}
                style={{
                  backgroundColor: 'transparent',
                  border: '1px solid #FFFDF1',
                  color: '#FFFDF1',
                  padding: '8px 16px',
                  borderRadius: '7px',
                  cursor: 'pointer',
                  fontFamily: 'IBM Plex Mono, monospace',
                  fontSize: '13px',
                  transition: 'opacity 0.2s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
              >
                cancel
              </button>
              <button
                onClick={handleCommentSave}
                style={{
                  backgroundColor: '#63B9AB',
                  border: 'none',
                  color: '#252422',
                  padding: '8px 16px',
                  borderRadius: '7px',
                  cursor: 'pointer',
                  fontFamily: 'IBM Plex Mono, monospace',
                  fontSize: '13px',
                  transition: 'opacity 0.2s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.85'}
                onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
              >
                save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default function TodolingsApp() {
  const [tasks, setTasks] = useState([]);
  const [showDone, setShowDone] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [draggedTask, setDraggedTask] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [passwordInput, setPasswordInput] = useState('');
  const [passwordError, setPasswordError] = useState(false);
  const [currentPage, setCurrentPage] = useState('tasks');
  const [invoices, setInvoices] = useState([]);

  const CORRECT_PASSWORD = 't0d0l1ngs$ndr4&S3rg3';

  useEffect(() => {
    checkAuthentication();
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      const tasksRef = ref(database, 'tasks');
      const unsubscribe = onValue(tasksRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const tasksArray = Object.keys(data).map(key => ({
            id: key,
            ...data[key]
          }));
          // Sort by order field if it exists
          tasksArray.sort((a, b) => (a.order || 0) - (b.order || 0));
          setTasks(tasksArray);
        } else {
          const defaultTasks = [
            {
              id: '1',
              task: 'design homepage mockup',
              person: 'andra',
              priority: 'high',
              status: 'in progress',
              project: 'website redesign',
              deadline: '2025-12-05',
              comment: '',
              order: 1
            },
            {
              id: '2',
              task: 'client meeting prep',
              person: 'serj',
              priority: 'medium',
              status: 'to do',
              project: 'brand identity',
              deadline: '2025-12-01',
              comment: '',
              order: 2
            },
            {
              id: '3',
              task: 'export final assets',
              person: 'both',
              priority: 'low',
              status: 'done',
              project: 'logo project',
              deadline: '2025-11-28',
              comment: '',
              order: 3
            }
          ];
          setTasks(defaultTasks);
          defaultTasks.forEach(task => {
            const taskData = {...task};
            delete taskData.id;
            set(ref(database, `tasks/${task.id}`), taskData);
          });
        }
        setIsLoading(false);
      });

      return () => unsubscribe();
    }
  }, [isAuthenticated]);
  
  useEffect(() => {
  if (isAuthenticated) {
    const timeout = setTimeout(() => {
      console.log('Firebase timeout for invoices - loading anyway');
    }, 5000);

    const invoicesRef = ref(database, 'invoices');
    const unsubscribe = onValue(invoicesRef, (snapshot) => {
      clearTimeout(timeout);
      const data = snapshot.val();
      if (data) {
        const invoicesArray = Object.keys(data).map(key => ({
          id: key,
          ...data[key]
        }));
        invoicesArray.sort((a, b) => (a.order || 0) - (b.order || 0));
        setInvoices(invoicesArray);
      } else {
        setInvoices([]);
      }
    }, (error) => {
      console.error('Firebase error for invoices:', error);
      clearTimeout(timeout);
    });

    return () => {
      clearTimeout(timeout);
      unsubscribe();
      };
    }
  }, [isAuthenticated]);

  const checkAuthentication = async () => {
    const authValue = localStorage.getItem('todolings-auth');
    if (authValue === 'authenticated') {
      setIsAuthenticated(true);
    } else {
      setIsLoading(false);
    }
  };

  const handlePasswordSubmit = (e) => {
    if (e) e.preventDefault();
    
    if (passwordInput === CORRECT_PASSWORD) {
      localStorage.setItem('todolings-auth', 'authenticated');
      setIsAuthenticated(true);
      setPasswordError(false);
    } else {
      setPasswordError(true);
      setPasswordInput('');
    }
  };

  const activeTasks = tasks.filter(t => t.status !== 'done');
  const doneTasks = tasks.filter(t => t.status === 'done');

  const addTask = () => {
    const newTaskId = Date.now().toString();
    const maxOrder = tasks.reduce((max, t) => Math.max(max, t.order || 0), 0);
    const newTask = {
      task: 'new task',
      person: 'andra',
      priority: 'medium',
      status: 'to do',
      project: '',
      deadline: '',
      comment: '',
      order: maxOrder + 1
    };
    set(ref(database, `tasks/${newTaskId}`), newTask);
  };

  const deleteTask = (id) => {
    remove(ref(database, `tasks/${id}`));
  };

  const updateTaskField = (id, field, value) => {
    const task = tasks.find(t => t.id === id);
    if (task) {
      const updatedTask = { ...task, [field]: value };
      delete updatedTask.id;
      set(ref(database, `tasks/${id}`), updatedTask);
    }
  };
  const addInvoice = () => {
  const newInvoiceId = Date.now().toString();
  const maxOrder = invoices.reduce((max, i) => Math.max(max, i.order || 0), 0);
  const newInvoice = {
    name: 'new invoice',
    project: '',
    sum: 0,
    status: 'planned',
    location: 'Dubai',
    deadline: '',
    paid: false,
    paidDate: null,
    order: maxOrder + 1
  };
  set(ref(database, `invoices/${newInvoiceId}`), newInvoice);
};

const deleteInvoice = (id) => {
  remove(ref(database, `invoices/${id}`));
};

const updateInvoiceField = (id, field, value) => {
  const invoice = invoices.find(i => i.id === id);
  if (invoice) {
    const updatedInvoice = { ...invoice, [field]: value };
    delete updatedInvoice.id;
    set(ref(database, `invoices/${id}`), updatedInvoice);
  }
};

const markInvoicePaid = (id) => {
  const invoice = invoices.find(i => i.id === id);
  if (invoice) {
    const updatedInvoice = { ...invoice, paid: true, paidDate: new Date().toISOString() };
    delete updatedInvoice.id;
    set(ref(database, `invoices/${id}`), updatedInvoice);
  }
};

const handleInvoiceDragStart = (e, invoice) => {
  setDraggedTask(invoice); // Reusing draggedTask state
  e.dataTransfer.effectAllowed = 'move';
};

const handleInvoiceDrop = (e, targetInvoice) => {
  e.preventDefault();
  if (!draggedTask || draggedTask.id === targetInvoice.id) return;

  const draggedIndex = invoices.findIndex(i => i.id === draggedTask.id);
  const targetIndex = invoices.findIndex(i => i.id === targetInvoice.id);

  const reorderedInvoices = [...invoices];
  reorderedInvoices.splice(draggedIndex, 1);
  reorderedInvoices.splice(targetIndex, 0, draggedTask);

  reorderedInvoices.forEach((invoice, index) => {
    const invoiceData = { ...invoice };
    delete invoiceData.id;
    invoiceData.order = index;
    set(ref(database, `invoices/${invoice.id}`), invoiceData);
  });

  setDraggedTask(null);
};

const calculatePaidThisYear = () => {
  const currentYear = new Date().getFullYear();
  return invoices
    .filter(i => {
      if (!i.paid || !i.paidDate) return false;
      const paidYear = new Date(i.paidDate).getFullYear();
      return paidYear === currentYear;
    })
    .reduce((sum, i) => sum + (parseFloat(i.sum) || 0), 0);
};

const calculateOwed = () => {
  return invoices
    .filter(i => !i.paid)
    .reduce((sum, i) => sum + (parseFloat(i.sum) || 0), 0);
};

  const handleDragStart = (e, task) => {
    setDraggedTask(task);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e, targetTask) => {
    e.preventDefault();
    if (!draggedTask || draggedTask.id === targetTask.id) return;

    const draggedIndex = tasks.findIndex(t => t.id === draggedTask.id);
    const targetIndex = tasks.findIndex(t => t.id === targetTask.id);

    // Reorder tasks
    const reorderedTasks = [...tasks];
    reorderedTasks.splice(draggedIndex, 1);
    reorderedTasks.splice(targetIndex, 0, draggedTask);

    // Update order field for all tasks
    reorderedTasks.forEach((task, index) => {
      const taskData = { ...task };
      delete taskData.id;
      taskData.order = index;
      set(ref(database, `tasks/${task.id}`), taskData);
    });

    setDraggedTask(null);
  };

  if (isLoading) {
    return (
      <div style={{
        backgroundColor: '#252422',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#FFFDF1',
        fontFamily: 'IBM Plex Mono, monospace'
      }}>
        <link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400&display=swap" rel="stylesheet" />
        loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div style={{
        backgroundColor: '#252422',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'IBM Plex Mono, monospace'
      }}>
        <link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400&display=swap" rel="stylesheet" />
        <div style={{
          backgroundColor: '#403D38',
          padding: '40px',
          borderRadius: '7px',
          maxWidth: '400px',
          width: '90%',
          textAlign: 'center'
        }}>
          <h1 style={{
            color: '#FFFDF1',
            fontSize: '24px',
            fontWeight: '400',
            marginTop: 0,
            marginBottom: '24px',
            letterSpacing: '0.05em'
          }}>todolings</h1>
          
          <div>
            <input
              type="password"
              value={passwordInput}
              onChange={(e) => setPasswordInput(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handlePasswordSubmit(e)}
              placeholder="enter password"
              style={{
                width: '100%',
                backgroundColor: '#252422',
                border: passwordError ? '2px solid #DA693E' : 'none',
                borderRadius: '7px',
                padding: '12px',
                color: '#FFFDF1',
                fontFamily: 'IBM Plex Mono, monospace',
                fontSize: '13px',
                outline: 'none',
                marginBottom: '16px',
                boxSizing: 'border-box'
              }}
            />
            
            {passwordError && (
              <div style={{
                color: '#DA693E',
                fontSize: '13px',
                marginBottom: '16px'
              }}>
                incorrect password
              </div>
            )}
            
            <button
              onClick={handlePasswordSubmit}
              style={{
                width: '100%',
                backgroundColor: '#63B9AB',
                border: 'none',
                color: '#252422',
                padding: '12px',
                borderRadius: '7px',
                cursor: 'pointer',
                fontFamily: 'IBM Plex Mono, monospace',
                fontSize: '13px',
                transition: 'opacity 0.2s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.opacity = '0.85'}
              onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
            >
              enter
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      backgroundColor: '#252422',
      minHeight: '100vh',
      padding: '40px',
      fontFamily: 'IBM Plex Mono, monospace'
    }}>
      <link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400&display=swap" rel="stylesheet" />
      <link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400&display=swap" rel="stylesheet" />
    
    <BurgerMenu currentPage={currentPage} onPageChange={setCurrentPage} />
   
      <style>{`
        select {
          background-color: #403D38;
        }
        select option {
          background-color: #403D38 !important;
          color: #FFFDF1;
        }
        input[type="date"]::-webkit-calendar-picker-indicator {
          filter: invert(1) hue-rotate(180deg);
          cursor: pointer;
        }
        input[type="date"]::-webkit-datetime-edit {
          color: #FFFDF1;
        }
        input[type="date"]::-webkit-datetime-edit-fields-wrapper {
          color: #FFFDF1;
        }
        input[type="date"]::-webkit-datetime-edit-text,
        input[type="date"]::-webkit-datetime-edit-month-field,
        input[type="date"]::-webkit-datetime-edit-day-field,
        input[type="date"]::-webkit-datetime-edit-year-field {
          color: #FFFDF1;
        }
        .icon-button:hover {
          opacity: 1 !important;
          transform: scale(1.1);
        }
      `}</style>
      {currentPage === 'tasks' && (
      <div style={{maxWidth: '1400px', margin: '0 auto'}}>
        <div style={{
          textAlign: 'center',
          marginBottom: '48px',
          position: 'relative'
        }}>
          <img 
            src="/Graphlings logo.png" 
            alt="todolings logo" 
            style={{
              maxWidth: '200px',
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
              opacity: 0.3,
              zIndex: 0
            }} 
          />
          <h1 style={{
            color: '#FFFDF1',
            fontSize: '24px',
            fontWeight: '400',
            margin: 0,
            position: 'relative',
            zIndex: 1,
            letterSpacing: '0.5em'
          }}>todolings</h1>
        </div>

        <div style={{marginBottom: '40px'}}>
          <h2 style={{
            color: '#FFFDF1',
            fontSize: '16px',
            fontWeight: '400',
            marginBottom: '16px'
          }}>active</h2>

          {activeTasks.length === 0 ? (
            <div style={{color: '#FFFDF1', opacity: 0.5, fontSize: '13px'}}>no active tasks</div>
          ) : (
            activeTasks.map(task => (
              <TaskRow 
                key={task.id} 
                task={task}
                onUpdate={updateTaskField}
                onDelete={deleteTask}
                onDragStart={handleDragStart}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
              />
            ))
          )}

          <button
            onClick={addTask}
            style={{
              backgroundColor: '#63B9AB',
              color: '#252422',
              border: 'none',
              padding: '12px 16px',
              borderRadius: '7px',
              cursor: 'pointer',
              fontFamily: 'IBM Plex Mono, monospace',
              fontSize: '13px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              width: '100%',
              marginTop: '8px',
              transition: 'opacity 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.opacity = '0.85'}
            onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
          >
            <Plus size={16} />
            add task
          </button>
        </div>

        <div>
          <div
            onClick={() => setShowDone(!showDone)}
            style={{
              color: '#FFFDF1',
              fontSize: '16px',
              fontWeight: '400',
              marginBottom: '16px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            done ({doneTasks.length})
            {showDone ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
          </div>

          {showDone && (
            doneTasks.length === 0 ? (
              <div style={{color: '#FFFDF1', opacity: 0.5, fontSize: '13px'}}>no done tasks</div>
            ) : (
              doneTasks.map(task => (
                <TaskRow 
                  key={task.id} 
                  task={task}
                  onUpdate={updateTaskField}
                  onDelete={deleteTask}
                  onDragStart={handleDragStart}
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                />
              ))
            )
          )}
        </div>
      </div>
      )}
    {currentPage === 'admin' && (
  <div style={{maxWidth: '1400px', margin: '0 auto'}}>

      {/* TO EMIT SECTION - ADD THIS */}
    <div style={{marginBottom: '40px'}}>
      <h2 style={{
        color: '#FFFDF1',
        fontSize: '16px',
        fontWeight: '400',
        marginBottom: '16px'
      }}>to emit</h2>

      {invoices.filter(i => i.status === 'planned').length === 0 ? (
        <div style={{color: '#FFFDF1', opacity: 0.5, fontSize: '13px'}}>no planned invoices</div>
      ) : (
        invoices.filter(i => i.status === 'planned').map(invoice => (
          <InvoiceRow 
            key={invoice.id} 
            invoice={invoice}
            onUpdate={updateInvoiceField}
            onDelete={deleteInvoice}
            onMarkPaid={markInvoicePaid}
            onDragStart={handleInvoiceDragStart}
            onDragOver={handleDragOver}
            onDrop={handleInvoiceDrop}
          />
        ))
      )}

      <button
        onClick={addInvoice}
        style={{
          backgroundColor: '#63B9AB',
          color: '#252422',
          border: 'none',
          padding: '12px 16px',
          borderRadius: '7px',
          cursor: 'pointer',
          fontFamily: 'IBM Plex Mono, monospace',
          fontSize: '13px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          width: '100%',
          marginTop: '8px',
          transition: 'opacity 0.2s ease'
        }}
        onMouseEnter={(e) => e.currentTarget.style.opacity = '0.85'}
        onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
      >
        <Plus size={16} />
        add invoice
      </button>
    </div>
    {/* END TO EMIT SECTION */}

    <div style={{marginBottom: '40px'}}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '16px'
      }}>
        <h2 style={{
          color: '#FFFDF1',
          fontSize: '16px',
          fontWeight: '400',
          margin: 0
        }}>invoices</h2>
        
        <div style={{
          display: 'flex',
          gap: '32px',
          fontFamily: 'IBM Plex Mono, monospace',
          fontSize: '13px'
        }}>
          <div>
            <span style={{color: '#FFFDF1', opacity: 0.6}}>paid this year: </span>
            <span style={{color: '#63B9AB', fontWeight: '400'}}>
              ${calculatePaidThisYear().toFixed(2)}
            </span>
          </div>
          <div>
            <span style={{color: '#FFFDF1', opacity: 0.6}}>owed: </span>
            <span style={{color: '#DA693E', fontWeight: '400'}}>
              ${calculateOwed().toFixed(2)}
            </span>
          </div>
        </div>
      </div>

      {invoices.filter(i => i.status === 'emitted' && !i.paid).length === 0 ? (
        <div style={{color: '#FFFDF1', opacity: 0.5, fontSize: '13px'}}>no active invoices</div>
      ) : (
        invoices.filter(i => i.status === 'emitted' && !i.paid).map(invoice => (
          <InvoiceRow 
            key={invoice.id} 
            invoice={invoice}
            onUpdate={updateInvoiceField}
            onDelete={deleteInvoice}
            onMarkPaid={markInvoicePaid}
            onDragStart={handleInvoiceDragStart}
            onDragOver={handleDragOver}
            onDrop={handleInvoiceDrop}
          />
        ))
      )}
    </div>

    <div>
      <div
        onClick={() => setShowDone(!showDone)}
        style={{
          color: '#FFFDF1',
          fontSize: '16px',
          fontWeight: '400',
          marginBottom: '16px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}
      >
        paid ({invoices.filter(i => i.paid).length})
        {showDone ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      </div>

      {showDone && (
        invoices.filter(i => i.paid).length === 0 ? (
          <div style={{color: '#FFFDF1', opacity: 0.5, fontSize: '13px'}}>no paid invoices</div>
        ) : (
          invoices.filter(i => i.paid).map(invoice => (
            <InvoiceRow 
              key={invoice.id} 
              invoice={invoice}
              onUpdate={updateInvoiceField}
              onDelete={deleteInvoice}
              onMarkPaid={markInvoicePaid}
              onDragStart={handleInvoiceDragStart}
              onDragOver={handleDragOver}
              onDrop={handleInvoiceDrop}
            />
          ))
        )
      )}
    </div>
  </div>
)}
    </div>
  );
}